import { useState, forwardRef, useEffect } from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Typography } from "@mui/material";
import Checkbox from "../../../components/shared/checkbox/Checkbox";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const MultiSelectQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      myAnswer,
      isEdit,
      latestStepQuestion,
      payload,
      showedQuestions,
    },
    ref
  ) => {
    // const [myAnswer, setMyAnswer] = useState([]);
    const [textValue, setTextValue] = useState("");
    const [checked, setChecked] = useState([]);
    const [finalChoices, setFinalChoices] = useState([]);
    const [show, setShow] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const isMobile = useMediaQuery("(max-width:900px)");

    useEffect(() => {
      if (data.withTextField) {
        const choices = data.choises.map((item) => item.value);
        const theValue = myAnswer.filter((item) => !choices.includes(item));
        setTextValue(theValue[0]);
        if (theValue.length !== 0) {
          setChecked([...myAnswer, "other"].filter((el) => el !== theValue[0]));
        } else {
          setChecked(myAnswer);
        }
      }
    }, [myAnswer]);

    const handleMultiValue = (value, choise) => {
      if (data.id === 15) {
        if (!checked.includes(choise)) {
          if (
            checked.length + 1 <= payload["datacenter_number_C"] ||
            payload["datacenter_number_C"] === 3
          ) {
            setChecked([...checked, value]);
            setShowMessage(false);
          } else {
            setShowMessage(true);
          }
        } else {
          setChecked(checked.filter((el) => el !== value));
          setShowMessage(false);
        }

        // setChecked(
        //   !checked.includes(choise)
        //     ? checked.length + 1 <= payload["datacenter_number_C"]
        //       ? [...checked, value]
        //       : setShowMessage(true)
        //     : checked.filter((el) => el !== value)
        // );
      } else {
        setChecked(
          !checked.includes(choise)
            ? [...checked, value]
            : checked.filter((el) => el !== value)
        );
      }
      if (myAnswer.includes(choise) && myAnswer.length === 1) {
        setShow(true);
      } else {
        setShow(false);
      }
      // setMyAnswer(!myAnswer.includes(choise) ? [...myAnswer, value] : myAnswer.filter(el => el !== value));
      if (data.withTextField) {
        handlePayload(
          data,
          !checked.includes(choise)
            ? [...checked, value]
            : checked.filter((el) => el !== value)
        );
      } else {
        handlePayload(
          data,
          !myAnswer.includes(choise)
            ? data.id === 15
              ? myAnswer.length + 1 <= payload["datacenter_number_C"] ||
                payload["datacenter_number_C"] === 3
                ? [...myAnswer, value]
                : myAnswer.filter((el) => el !== value)
              : [...myAnswer, value]
            : myAnswer.filter((el) => el !== value)
        );
      }
    };

    // useEffect(() => {
    //   return () => {
    //     if (data.withTextField) {
    //       handlePayload(
    //         data,
    //         checked.includes("other") && textValue !== ""
    //           ? [...checked, textValue].filter((el) => el !== "other")
    //           : checked.filter((el) => el !== textValue)
    //       );
    //     }
    //   };
    // }, [textValue]);

    useEffect(() => {
      if (data.id === 42) {
        if (myAnswer.includes("CMS")) {
          data.nextQuestion = 43;
          data.nextStepQuestion = 43;
        } else {
          data.nextQuestion = 44;
          data.nextStepQuestion = 44;
        }
      }
    }, [myAnswer, data.id]);

    const nextQuestionHandler = (height, value) => {
      if (data.withTextField) {
        if (checked.includes("other")) {
          handlePayload(
            data,
            [...value, textValue].filter((el) => el !== "other")
          );
          scrollToQuestion(
            data,
            height,
            [...value, textValue].filter((el) => el !== "other")
          );
        } else {
          scrollToQuestion(data, height, value);
          handlePayload(
            data,
            value.filter((el) => el !== textValue)
          );
        }
      } else {
        scrollToQuestion(data, height, value);
        handlePayload(data, value);
      }
    };
    const { t } = useTranslation();

    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          {/* <br></br> */}
          {/* <SelectList></SelectList> */}
          <Grid container spacing={2} m={0}>
            {data.choises.map((choise, index) => (
              <Grid item xs={choise.xs} lg={choise.lg} key={`check${index}`}>
                <Checkbox
                  title={t(choise)}
                  id={choise.id}
                  checked={
                    data.withTextField
                      ? checked?.includes(choise)
                      : myAnswer?.includes(choise)
                  }
                  disabled={showMessage}
                  value={choise}
                  nextQuestionHandler={(value) => {
                    handleMultiValue(value, choise);
                  }}
                />
              </Grid>
            ))}
          </Grid>
          {checked.includes("other") && (
            <>
              <br></br>
              <TextField
                id="outlined-basic"
                placeholder={t("other")}
                variant="outlined"
                fullWidth
                value={textValue}
                onChange={(e) => {
                  setTextValue(e.target.value);
                  handlePayload(
                    data,
                    checked.includes("other") && e.target.value !== ""
                      ? [...checked, e.target.value].filter(
                          (el) => el !== "other"
                        )
                      : checked.filter((el) => el !== e.target.value)
                  );
                }}
              />
            </>
          )}
          {show && (
            <span className="error-message-autocomplete">
              {t("required_field")}
            </span>
          )}

          {showMessage && (
            <span className="error-message-autocomplete">
              {t("datacenter_number")}
            </span>
          )}

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={(option) => {
                  nextQuestionHandler(
                    ref.current.clientHeight,
                    data.withTextField ? checked : myAnswer
                  );
                }}
                disabled={
                  data.withTextField
                    ? checked?.length === 0
                    : myAnswer?.length === 0
                }
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default MultiSelectQuestion;
